export default {
  Success: 'success',
  Warning: 'warning',
  Error: 'error',
  Default: 'default'
}